// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"share-button_tooltip__1vugv","share_button":"share-button_share_button__G_J4N","success":"share-button_success__rTRIa","text":"share-button_text__AmpAE"};